import React, { useState } from "react";
import {
    PieChart,
    Pie,
    Cell,
    ResponsiveContainer,
    Sector,
} from "recharts";

const RevenueDetailsPie = ({
    digitalPayment,
    cashPayment,
    selectpaymenttype,
    setSelectpaymenttype,
    serviceTypes,
}) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const totalPayment = digitalPayment + cashPayment;
    const data = [
        { name: "Digital Payment", value: digitalPayment, color: "#003A71" },
        { name: "Cash Payment", value: cashPayment, color: "#FBB927" },
    ];

    // Custom active shape
    const renderActiveShape = (props) => {
        const RADIAN = Math.PI / 180;
        const {
            cx, cy, midAngle, innerRadius, outerRadius,
            startAngle, endAngle, fill, payload, percent, value
        } = props;

        const sin = Math.sin(-RADIAN * midAngle);
        const cos = Math.cos(-RADIAN * midAngle);

        // shorten connector distance
        const sx = cx + (outerRadius + 4) * cos;
        const sy = cy + (outerRadius + 4) * sin;
        const mx = cx + (outerRadius + 10) * cos; // was +30
        const my = cy + (outerRadius + 10) * sin;
        const ex = mx + (cos >= 0 ? 1 : -1) * 16; // less horizontal offset
        const ey = my;
        const textAnchor = cos >= 0 ? "start" : "end";

        return (
            <g>
                <text
                    x={cx}
                    y={cy}
                    dy={6}
                    textAnchor="middle"
                    fill={fill}
                    fontSize={11}
                    className="font-semibold"
                >
                    {payload.name}
                </text>
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={innerRadius}
                    outerRadius={outerRadius}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
                <Sector
                    cx={cx}
                    cy={cy}
                    innerRadius={outerRadius + 4}
                    outerRadius={outerRadius + 8}
                    startAngle={startAngle}
                    endAngle={endAngle}
                    fill={fill}
                />
                {/* shorter connector line */}
                <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
                <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
                <text
                    x={ex + (cos >= 0 ? 1 : -1) * 10}
                    y={ey}
                    textAnchor={textAnchor}
                    fill="#333"
                    fontSize={10}
                >
                    ₹{value.toLocaleString()}
                </text>
                <text
                    x={ex + (cos >= 0 ? 1 : -1) * 10}
                    y={ey}
                    dy={14}
                    textAnchor={textAnchor}
                    fill="#999"
                    fontSize={9}
                >
                    {(percent * 100).toFixed(1)}%
                </text>
            </g>
        );
    };



    return (
        <div className="bg-white rounded-xl shadow p-6 flex gap-6">
            {/* Left Summary */}
            <div className="w-[30%] space-y-4">
                <h3 className="text-md font-semibold text-[#003A71]">Revenue Details</h3>

                <div className="p-3 rounded-lg border bg-white">
                    <div className="text-sm text-gray-600">Total Revenue</div>
                    <div className="text-xl font-bold text-[#003A71]">₹{totalPayment.toLocaleString()}</div>
                </div>

                <div className="p-3 rounded-lg border bg-white">
                    <div className="text-sm text-gray-600">Digital Payment</div>
                    <div className="text-xl font-bold text-[#003A71]">₹{digitalPayment.toLocaleString()}</div>
                </div>

                <div className="p-3 rounded-lg border bg-white">
                    <div className="text-sm text-gray-600">Cash Payment</div>
                    <div className="text-xl font-bold text-[#FBB927]">₹{cashPayment.toLocaleString()}</div>
                </div>
            </div>

            {/* Right PieChart */}
            <div className="w-[70%]">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-sm font-semibold text-[#003A71]">Revenue Distribution</h3>

                    {/* Service Type Selector */}
                    <select
                        className="bg-white text-gray-600 px-8 py-3 rounded-md border border-gray-300 text-sm"
                        value={selectpaymenttype}
                        onChange={(e) => setSelectpaymenttype(e.target.value)}
                    >
                        <option value="">All</option>
                        {serviceTypes.map((type) => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                </div>

                <ResponsiveContainer width="100%" height={220}>
                    <PieChart>
                        <Pie
                            activeIndex={activeIndex}
                            activeShape={renderActiveShape}
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius={70}
                            outerRadius={100}
                            dataKey="value"
                            onMouseEnter={(_, index) => setActiveIndex(index)}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div >
    );
};

export default RevenueDetailsPie;
